import { req } from './axiosFun'
import config from './config'

var url = config.apiBase

export const whiteDevicePage = (params) => { return req("get", url + "/admin/web/whiteDevicePage", params) }
export const whiteDeviceDelete = (params) => { return req("post", url + "/admin/web/whiteDeviceDelete", params) }
export const whiteIpPage = (params) => { return req("get", url + "/admin/web/whiteIpPage", params) }
export const whiteIpDelete = (params) => { return req("post", url + "/admin/web/whiteIpDelete", params) }



// WEBPACK FOOTER //
// ./src/api/whitelistMG.js